// Create arc's start and end point
const polarToCartesian = (
  centerX: number,
  centerY: number,
  radius: number,
  angleInDegrees: number,
): { x: number; y: number } => {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180;
  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians),
  };
};

// Create description for an svg path, creating one single arc
export const describeArc = (
  x: number,
  y: number,
  radius: number,
  startAngle: number,
  endAngle: number,
): string => {
  const start = polarToCartesian(x, y, radius, endAngle);
  const end = polarToCartesian(x, y, radius, startAngle);
  const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
  const d = [
    'M',
    start.x,
    start.y,
    'A',
    radius,
    radius,
    0,
    largeArcFlag,
    0,
    end.x,
    end.y,
  ].join(' ');
  return d;
};

/**
 * Wraps an index to ensure it falls within the valid range of array indices.
 * @param totalElementCount amount of elements in the array
 * @param index desired index, can be negative or larger than totalElementCount
 * @returns actual index in the array
 */
export const circularIndex = (totalElementCount: number, index: number): number =>
  (totalElementCount + (index % totalElementCount)) % totalElementCount;
